import MasterLayout from "@/layouts/master";
export default [{
    path: "/servicios",
    component: MasterLayout,
    children: [{
            path: "afiliacion",
            name: "servicios.afiliacion",
            component: () =>
                import ("@/views/servicios/afiliacion/index.vue")
        },
        {
            path: "aportes",
            name: "servicios.aportes",
            component: () =>
                import ("@/views/servicios/aportes/index.vue")
        },
        // {
        //     path: "pendientes",
        //     name: "servicios.pendientes",
        //     component: () =>
        //         import ("@/views/servicios/pendientes/index.vue")
        // },
        {
            path: "listados",
            name: "servicios.listados",
            component: () =>
                import ("@/views/servicios/listados/index.vue")
        },
    ]
}]